<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
	<path d="M22.25 23.25h-7.5a1 1 0 01-1-1V1.75a1 1 0 011-1h7.5a1 1 0 011 1v20.5a1 1 0 01-1 1z"/>
	<path d="M23 24h-9a1 1 0 01-1-1V1a1 1 0 011-1h9a1 1 0 011 1v22a1 1 0 01-1 1zM15.5 1.5a1 1 0 00-1 1v19a1 1 0 001 1h6a1 1 0 001-1v-19a1 1 0 00-1-1zM9.25 23.25h-7.5a1 1 0 01-1-1V1.75a1 1 0 011-1h7.5a1 1 0 011 1v20.5a1 1 0 01-1 1z"/>
	<path d="M10 24H1a1 1 0 01-1-1V1a1 1 0 011-1h9a1 1 0 011 1v22a1 1 0 01-1 1zM2.5 1.5a1 1 0 00-1 1v19a1 1 0 001 1h6a1 1 0 001-1v-19a1 1 0 00-1-1z"/>
	</svg>
</template>